import React from "react";

const ErrorDiv = ({errorText} ) =>
{
   const errmsg = errorText != null && errorText.length !== 0 ? errorText : "Invalid Value" ;

   const className = 'input-error-visible'  ;

   return <div className={className}>{errmsg}</div>
}

export default ErrorDiv ;
